import { topicsItems } from '@/mocks/home';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line',
  hot: 'ri-fire-line',
  new: 'ri-sparkling-line',
};

const trendColors: Record<string, string> = {
  up: 'text-primary-500',
  hot: 'text-accent-500',
  new: 'text-secondary-500',
};

const catColors: Record<string, string> = {
  '明星': 'bg-primary-100 text-primary-700',
  '综艺': 'bg-secondary-100 text-secondary-700',
  '网红': 'bg-accent-100 text-accent-700',
  '音乐': 'bg-secondary-100 text-secondary-700',
  '体育': 'bg-primary-100 text-primary-700',
  '直播': 'bg-accent-100 text-accent-700',
  '海外': 'bg-secondary-100 text-secondary-700',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              热门话题
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
              实时追踪全网最热门的黑料话题
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
            {topicsItems.map((item, i) => (
              <a
                key={i}
                href="#"
                className="flex items-center justify-between p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all duration-200 cursor-pointer group"
              >
                <div className="flex items-center gap-3 min-w-0">
                  <span className={`text-lg ${trendColors[item.trend]} shrink-0`}>
                    <i className={trendIcons[item.trend]}></i>
                  </span>
                  <div className="min-w-0">
                    <p className="text-sm font-medium text-foreground-800 truncate group-hover:text-primary-600 transition-colors duration-200">
                      {item.tag}
                    </p>
                    <div className="flex items-center gap-2 mt-1">
                      <span className={`text-xs px-1.5 py-0.5 rounded ${catColors[item.category] || 'bg-background-200 text-foreground-500'} whitespace-nowrap`}>
                        {item.category}
                      </span>
                    </div>
                  </div>
                </div>
                <span className="text-sm font-semibold text-accent-600 shrink-0 ml-3 whitespace-nowrap">
                  {item.heat}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}